import axios from "axios";
import { link } from "./url";

const makePay = (el) => axios.post(`${link}/api/payment`, el);

export default { makePay };
